export default function generateHexColor() {
	const number = Math.floor(Math.random() * 16777216)
	return `#${number.toString(16).padStart(6, '0')}`
}